<template>
  <div id="app">
    <div v-if="appConfig.lang" class="home_configurador">
      <div
      v-if="num > 0 && compatibility.typeReference"
      class="selectedReference">
        <h2>{{$t(`${compatibility.typeReference.value}['title']`)}} </h2>
      </div>

      <SelectCompatibilityType
      @setCompatibilityType="setItem"
      :appMarket="appConfig.appMarket"
      :appLocale="appConfig.lang"
      v-if="num === 0"/>

      <SelectArticleType
      @setArticleType="setItem"
      :appMarket="appConfig.appMarket"
      :appLocale="appConfig.lang"
      :compatibilityType="compatibility.compatibilityType.value"
      v-if="num === 1"/>

      <SelectBrand
      @setBrand="setItem"
      :appMarket="appConfig.appMarket"
      :appLocale="appConfig.lang"
      :compatibilityType="compatibility.compatibilityType.value"
      :articleType="compatibility.articleType.value"
      v-if="num === 2"/>

      <SelectIumodel
      @setIumodel="setItem"
      :appMarket="appConfig.appMarket"
      :appLocale="appConfig.lang"
      :compatibilityType="compatibility.compatibilityType.value"
      :articleType="compatibility.articleType.value"
      :brand="compatibility.brand.value"
      v-if="num === 3"/>

      <Result
      :appMarket="appConfig.appMarket"
      :appLocale="appConfig.lang"
      :compatibilityType="compatibility.compatibilityType.value"
      :articleType="compatibility.articleType.value"
      :brand="compatibility.brand.value"
      :iumodel="compatibility.iumodel.value"
      v-if="num === 'last'"/>

      <el-row class="botoneraVue">
        <el-col
        style="left: 0"
        :span="0.1"
        class="botones"
        v-if="num > 0 && num !== 'last'">
          <el-button
            @click="lastStep"
            type="warning"
            icon="el-icon-d-arrow-left" />
          </el-col>

          <el-col
          style="right: 0"
          :span="0.1"
          class="botones"
          v-if="num > 0 || num === 'last'">
            <el-button @click="resetStep" type="danger" icon="el-icon-refresh" />
          </el-col>

          <el-col
          style="left: 0"
          :span="0.1"
          class="botones"
          v-if="num === 'last' && app === false">
            <el-button
              @click="print($t('NamePdfFile'))"
              type="primary"
              icon="el-icon-printer" />
          </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Printd } from 'printd';
import store from '@/store';
import { hasProp } from '@/utils/validate.utils';
import {sanitizeStep} from '@/models/step.models';
import SelectCompatibilityType from './components/SelectCompatibilityType.vue';
import SelectArticleType from './components/SelectArticleType.vue';
import SelectBrand from './components/SelectBrand.vue';
import SelectIumodel from './components/SelectIumodel.vue';
import Result from './components/Result.vue';


export default {
  name: 'app',
  data() {
    return {
      app: false,
      compatibility: {},
      num: 0,
    };
  },
  components: {
    SelectCompatibilityType,
    SelectArticleType,
    SelectBrand,
    SelectIumodel,
    Result,
  },
  computed: {
    appConfig() {
      return store.getters.getSiteConfig;
    },
  },
  async created() {
    await store.dispatch('getSiteConfig');
    this.app = !!localStorage.getItem('app');
    this.setItemByParams(window.location.href);
  },
  methods: {
    setItem(item) {
      this.compatibility = { ...this.compatibility, ...item };
      this.num = item[Object.keys(item)].id;
      if (this.num === 1 && this.compatibility.compatibilityType.value === 'ZONIFIED') {
        this.compatibility = { ...this.compatibility, ...{'articleType':{value: 'COMMUNICATION_GATEWAY', id: 2}} };
        this.num +=1;
      }
    },
    lastStep() {
      const steps = sanitizeStep(this.compatibility);
      const lastStep = Math.max(...[...steps.keys()]);
      const lastObject = Object.keys(steps[lastStep])[0];
      delete this.compatibility[lastObject];
      this.num = lastStep;
      if (this.num === 1 && this.compatibility.compatibilityType.value === 'ZONIFIED') {
        this.num = 0;
        this.compatibility = {};
      }
    },
    resetStep() {
      this.num = 0;
      this.compatibility = {};
    },
    print(newTitle) {
            const titulo = document.title;
      document.title = newTitle;
      const d = new Printd();
      const style = `
      .blockPrint {
          display:block;
          width:100%;
          text-align: center;
       }
       .blockPrint img{
          width: 100%;
       }
       h3{
         font-weight: inherit;
       }`;
      d.print(document.getElementById('print'), style);
      document.title = titulo;
    },
    setItemByParams(url) {
      var params = {};
      var parser = document.createElement('a');
      parser.href = url;
      var query = parser.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair.length == 2 && pair[0] !== '' && pair[1] !== '') {
          params[pair[0]] = {
            id: i+1,
            value: decodeURIComponent(pair[1]),
          };
          this.setItem(params)
        }
        params = {};
      }
    }
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  //margin-top: 60px;
  height: 100%;
  width: 100%;
  display: inline-block;
}
.home_configurador {
  margin-top: 25px;
  min-height: 250px;
  top: 0;
}
.select {
  width: 100%;
  margin-bottom: 25px;
}
.centrar {
  text-align: center;
}
.botones {
  position: absolute;
}
.botoneraVue {
  margin-top: 15px;
  margin-bottom: 15px;
  min-height: 50px;
  font-size: 16px;
}
.selectedReference{
  text-align: left;
  margin-bottom: 30px;
  margin-left: 30px;
}
</style>
